require('./angular');
module.exports = angular;



//////////////////
// WEBPACK FOOTER
// ../~/angular/index.js
// module id = 3
// module chunks = 4